module.exports = __webpack_public_path__ + "static/media/Icono usuarios.61431606.svg";